import ExportFile from './ExportFile.vue'

ExportFile.install = Vue => {
    Vue.component(ExportFile.name, ExportFile)
}

export default ExportFile
